import React, { useEffect } from 'react';
import { formatCurrency, formatSqFeet, formatAddress, daysListed, imageResize, findImage,
        ShowValueWithIcon, decodeHtml, trackClick, trackBDX } from '../util/util.js';
import { Bed, Bathtub, Tape, House } from '../util/icons_svg.js';
import { HeartToggle } from '../util/toggle.js';

const convertPropType = (item) => {
    const propType = item.community_name
        ? item.community_name
        : item.property_type
            ? item.property_type
            : null;

    const mappedPropType = {
        "Single Family": "Single Family Home",
        "Multi-Family": "Multi-Family Home"
    }[propType];

    return mappedPropType === undefined
        ? propType
        : mappedPropType;
}

function SrpListItem({item, itemKey, clickFunction, hoverPin, reportingServerPath, affiliate}) {
    useEffect(() => {
        if (item.property.includes("_BHI")) {
            trackBDX(item.ad_number,affiliate, "Search");
        }
    }, []);
    
    const business_name = item.broker_business_name || item.property_management_name
    const enhancedBroker = (item.broker_marketing_level && item.broker_marketing_level.toUpperCase() === 'ENHANCED') ? true : false
    const enhancedAgent = (item.agent_marketing_level && item.agent_marketing_level.toUpperCase() === 'ENHANCED') ? true : false
    const isCommunity = (item.list_type && item.list_type.toUpperCase() === 'COMMUNITY') ? true : false
    const business_logo = item.broker_logo_135_60 ? item.broker_logo_135_60 : item.property_management_logo
    const agent_name = (item.agent_first_name && item.agent_last_name) ? item.agent_first_name + ' ' + item.agent_last_name : null
    const listingAddress = item.internet_address ? item.internet_address : item.address ? item.address : null;
    const cityStateZip = formatAddress(item.city, item.state, item.zipcode)
    const premier = item.premier_listing && item.premier_listing.toUpperCase() === 'ON';
    const showcase_home = item.showcase_home;
    const newConstructionArray = ['NEW', 'TO BE BUILT', 'UNDER CONSTRUCTION']
    const newConstruction = item.condition ? newConstructionArray.includes(item.condition.toUpperCase()) : null;
    const latLngId = item.latitude + item.longitude;
    const reportingTrackingPath = isCommunity
                                ? reportingServerPath + "MDAPT_SITE/" + item.source_id + ".gif?com_id=" + item.ad_id + ";mgmt_co_id=" + item.property_management_id
        : reportingServerPath + "MDRE_SITE/" + item.category_id + ".gif?aid=" + item.agent_id + ";bid=" + item.broker_id + ";lid=" + item.ad_id;
    
    return (
        <div className="srp-list-item"
            onClick={() => {
                // TRACK: listing_to_detail click
                trackClick('listing_to_detail_click',`detail_page: ${itemKey}`);
                clickFunction(item, itemKey)
            }}
            onMouseOver={() => hoverPin(latLngId, item.ad_id)}
            onMouseOut={() => hoverPin(null, null)}>
            <div className="srp-list-subcontainer">
                <div className="property-info parent-item">
                    <div className="listing-image-container">
                        {!!findImage(item.images)
                            ? <img className="listing-image sub-item" alt=""
                                   src={imageResize(findImage(item.images), 480)}/>
                            : <div className="listing-image-none"><House />Photos Coming Soon</div>
                        }
                    </div>
                </div>
                <HeartToggle
                    className="heart-toggle"
                    adId={item.ad_id}
                    origin="listing"
                />
                <div className="property-alerts">
                    {premier &&
                        <div className="premier-div">Premier</div>
                    }
                    {(!!item.just_listed && item.just_listed.toUpperCase() === 'ON')
                        ? <div className="just-listed-div">Just Listed</div>
                        : (!enhancedAgent && !enhancedBroker && !premier && !isCommunity)
                            ? <div className="just-listed-div">Listed {daysListed(item.date_created)}</div>
                            : null}
                    {!!showcase_home
                        ? <div className="showcase-div">Showcase</div>
                        : null}
                    {!!newConstruction
                        ? <div className="new-construction-div">New Construction</div>
                        : null}
                    {!!item.foreclosure
                        ? <div className="foreclosure-div">Foreclosure</div>
                        : null}
                    {!!item.open_house &&
                        <div className="open-house-div">
                            Open House:<br />
                            {decodeHtml(item.open_house)}
                        </div>
                    }
                    {!!item.special_offers
                        ? <div className="special-offers-div">Special Offer</div>
                        : null}
                </div>

                <div className="property-stats parent-item">
                    <div className="price">
                        <ShowValueWithIcon
                            do_not_display_rent = {item.do_not_display_rent}
                            list_type={item.list_type}
                            exact={item.price}
                            min={item.rent_min}
                            max={item.rent_max}
                            transform={formatCurrency}
                        />
                    </div>
                    <div className="property-dimensions">
                        <ShowValueWithIcon
                            list_type={item.list_type}
                            exact={item.beds}
                            min={item.bed_min}
                            max={item.bed_max}
                            field='bd'
                            icon={<Bed/>}
                        />
                        <ShowValueWithIcon
                            list_type={item.list_type}
                            exact={item.baths}
                            min={item.bath_min}
                            max={item.bath_max}
                            field='ba'
                            icon={<Bathtub/>}
                        />
                        <ShowValueWithIcon
                            list_type={item.list_type}
                            exact={item.number_sqfeet}
                            icon={<Tape/>}
                            transform={formatSqFeet}
                        />
                    </div>
                    <div className="location parent-item">
                        <div className="sub-item property-type">
                            {convertPropType(item)}
                        </div>
                        <div className="sub-item property-address">
                            {[listingAddress, cityStateZip].filter(i => i).map((i, index) => <span key={index} className="address-line">{i}</span>)}
                        </div>
                    </div>
                </div>
            </div>
             <div className="broker-agent">
                {(enhancedAgent || !!showcase_home || !!premier)
                    ? <div className="agent-enhanced">
                        {item.agent_logo_90_90
                            ? (<div className="agent-photo">
                                   <img className="agent-logo" alt="" src={item.agent_logo_90_90.replace('http://images-re','https://images-re')}/>
                               </div>)
                            : <div className="agent-photo-placeholder"></div>}
                        {!!agent_name &&
                            <div className="agent-name">{agent_name}</div>
                        }
                    </div>
                    : <div className="agent-enhanced-placeholder"></div>
                }
                {!!business_name &&
                    <div className="broker-info parent-item">
                        <div className="broker-logo">
                            {(!!business_logo && (enhancedBroker || !!showcase_home || !!premier || isCommunity)) &&
                                <img className="broker-logo" alt="" src={business_logo.replace('http://images-re','https://images-re')}/>
                            }
                        </div>
                        <div className="broker-name">{business_name}</div>
                    </div>
                }
            </div>
            <div className="tracker">
                <img alt="" src={isCommunity ? reportingTrackingPath + ";pc=401" : reportingTrackingPath + ";pc=200"} />
                {premier &&
                    <img alt="" src={isCommunity ? reportingTrackingPath + ";pc=405" : reportingTrackingPath + ";pc=462"} />}
            </div>
        </div>
    )
}

export default SrpListItem;
